var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { triggerAnalyticsEvent } from 'syf-js-utilities';
import { analyticsHelper } from '../const/analytics';
var _a = analyticsHelper.defaults, COUNTRY_LANGUAGE = _a.COUNTRY_LANGUAGE, CUSTOMER_TYPE = _a.CUSTOMER_TYPE, PAGE_NAME = _a.PAGE_NAME, PAGE_KIND = _a.PAGE_KIND, PRODUCT = _a.PRODUCT, PNL = _a.PNL, SITE_IDENTIFIER = _a.SITE_IDENTIFIER;
var Bootstrapper = window.Bootstrapper;
export { analyticsHelper, Bootstrapper };
var alertsTriggerAnalyticsEvent = function (eventOptions) {
    triggerAnalyticsEvent(__assign({ countryLanguage: COUNTRY_LANGUAGE, pnl: PNL, customerType: CUSTOMER_TYPE, product: PRODUCT, pageKind: PAGE_KIND, pageName: PAGE_NAME, siteIdentifier: SITE_IDENTIFIER }, eventOptions));
};
export default alertsTriggerAnalyticsEvent;
